<template>
  <div style="max-width: 1000px; margin: auto;">
    <agile :autoplay-speed="5000" :speed="2500" fade autoplay>
        <div class="slide">
            <img src="../assets/slide_1.jpg" style="width:100%">
        </div>
        <div class="slide">
            <img src="../assets/slide_2.jpg" style="width:100%">
        </div>
        <div class="slide">
            <img src="../assets/slide_3.jpg" style="width:100%">
        </div>
    </agile>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    msg: String
  },
  data: () => ({
    slideIndex: 1
  }),
  methods: {
    changeDivs: function (offset) {
      var n = this.slideIndex + offset
      this.slideIndex = n
      console.log('n', n)
      var i
      var x = document.getElementsByClassName('slides')
      if (n > x.length) { this.slideIndex = 1 }
      if (n < 1) { this.slideIndex = x.length }
      for (i = 0; i < x.length; i++) {
        if (x && x[i] && x[i].style) {
          x[i].style.display = 'none'
        }
      }
      if (x && x[this.slideIndex - 1] && x[this.slideIndex - 1].style) x[this.slideIndex - 1].style.display = 'block'
    }
  },
  mounted () {
    console.log('hello')
    this.changeDivs(this.slideIndex)
    setInterval(() => {
      console.log('change slide')
      this.changeDivs(1)
    }, 5000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  button {
    color: #000;
  }

  .slides {
    display:none;
  }

  .slides-container {
    height: 600px;
    max-width: 1000px;
    overflow: hidden;
    margin: auto;
  }

  .slider-caption {
    position: relative;
    bottom: 600px;
    color: #131313;
    font-size: 16px;
    width: 400px;
    text-align: left;
    padding: 20px;
    line-height: 0.8;
  }

  .project-title {
    font-size: 32px;
  }

  .agile__dot button {
    width: 10px;
  }

</style>
